import { useSSOContextStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/SSOContextStore";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import { useCallback } from "react";

// ts-prune-ignore-next will use in followup PR
export const useSSOProviderOptionsStore = () => {
  const [{ providers }, setStore] = useSSOContextStore(["providers"]);

  const setProviders = useCallback(
    (providers: SocialSignOnProvider[]) => {
      setStore({
        providers,
      });
    },
    [setStore]
  );

  const resetProviders = useCallback(() => {
    setStore({
      providers: [],
    });
  }, [setStore]);

  return {
    providers,
    setProviders,
    resetProviders,
  };
};
